export default {
  originCity: 'Velg avreiseby',
  destinationCity: 'Velg ankomstby',
  direct: 'Direkte',
  indirect: '1+ overganger',
  getPrices: 'Få priser',
  directAvailable: 'Direkte tilgjengelig fra',
}
